'use es6';

import PropTypes from 'prop-types';
const numberOrString = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
/**
 * Int ID or String Path
 */

const templateId = numberOrString;
const assetId = numberOrString;
const sessionId = numberOrString;
export default {
  assetId,
  templateId,
  sessionId
};